
import config from '../env.js'
export default {
    name: 'Logout',
    data: function () {
        return {
            message: 'It is processing...'
        }
    },
    methods: {
        getBaseUrl: function() {
            return process.env.VUE_APP_ENV === 'prod' ? config.prod_BaseUrl : config.uat_BaseUrl;
        },
        logout: async function (callbackfunc) {
            localStorage.removeItem("username")
            localStorage.removeItem("lang")
            console.log("logout(): cb start");
            callbackfunc();
            console.log("logout(): cb end");
        },
        callBackLogout: function () {
            this.$cookie.delete('accessToken', {domain: '.qhms.com'});
            this.$cookie.delete('refreshToken', {domain: '.qhms.com'});
            this.message = 'You can close the browser now.';
            var redirect_url = encodeURIComponent((process.env.VUE_APP_ENV === 'prod' ? config.prod_manulife_portal_url : (process.env.VUE_APP_ENV === 'uat' ? config.uat_manulife_portal_url : config.local_manulife_portal_url)))
            console.log(redirect_url);
            location.href = this.getBaseUrl() + '/spa/com/login/int_web.html#redirect_url=' + redirect_url + '&required2fa=0';
        }
    },
    mounted: async function() {
        await this.logout(this.callBackLogout);
    }
}
